var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumanLaptopLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 60,
    viewBox: "0 0 69 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0123 22.0327L12.0294 11.0164L1.0123 0L0.174129 0.838166L10.3523 11.0164L0.174129 21.1938L1.0123 22.0327Z",
    fill: "#315CD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4387 5.0332H17.9239V6.21929H27.4387V5.0332Z",
    fill: "#315CD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.527 5.0332H33.3596V6.21929H47.527V5.0332Z",
    fill: "#315CD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6656 5.0332H55.1709V6.21929H57.6656V5.0332Z",
    fill: "#315CD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8044 5.0332H64.719V6.21929H67.8044V5.0332Z",
    fill: "#315CD5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8041 10.4229H58.2902V11.6089H67.8041V10.4229Z",
    fill: "#315CD5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0093 10.4229H17.9239V11.6089H21.0093V10.4229Z",
    fill: "#315CD5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6656 15.8145H55.1709V17.0005H57.6656V15.8145Z",
    fill: "#315CD5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8044 15.8145H64.719V17.0005H67.8044V15.8145Z",
    fill: "#315CD5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4128 26.7964H0.592855V27.9825H13.4128V26.7964Z",
    fill: "#315CD5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1431 26.7964H50.7818V27.9825H54.1431V26.7964Z",
    fill: "#315CD5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8045 26.7964H63.6468V27.9825H67.8045V26.7964Z",
    fill: "#315CD5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8044 34.0596H54.9844V35.2457H67.8044V34.0596Z",
    fill: "#315CD5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6154 34.0596H14.2533V35.2457H17.6154V34.0596Z",
    fill: "#315CD5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75048 34.0596H0.592855V35.2457H4.75048V34.0596Z",
    fill: "#315CD5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8045 41.3232H63.6468V42.5093H67.8045V41.3232Z",
    fill: "#315CD5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3975 55.4693H58.9579C58.4526 53.4577 56.4133 45.0436 56.4133 40.4495C56.4133 37.308 51.6247 35.3454 47.0053 34.1815V34.0605H46.5174C43.3293 33.2927 40.3055 32.9013 39.0949 32.7637L37.7792 28.6006C38.2734 28.4266 38.7541 28.2234 39.2127 27.983H40.4819V27.1994C43.2423 25.2297 45.0514 22.0091 45.0514 18.3678C45.0514 17.9037 45.0127 17.449 44.9558 17.0007H47.5272V15.8146H44.7352C44.3564 14.2553 43.6471 12.8264 42.6753 11.6103H52.3672V10.4242H41.5683C39.631 8.62531 37.0454 7.51514 34.1988 7.51514C29.0954 7.51514 24.8145 11.0607 23.6616 15.8146H17.9249V17.0007H23.4418C23.3848 17.4498 23.3461 17.9044 23.3461 18.3678C23.3461 21.7687 24.9212 24.8059 27.3772 26.7969H21.3922V27.983H29.1848C29.6403 28.221 30.1155 28.4234 30.6057 28.5958L29.2892 32.7637C26.271 33.1069 11.97 35.0204 11.97 40.4495C11.97 40.7271 11.9613 41.0204 11.947 41.3233H0.593042V42.5094H11.8648C11.4426 47.2134 9.8619 53.7297 9.42621 55.4685H0V60.0002H68.3975V55.4693ZM47.5462 55.4693H20.8514V42.2342C20.8514 41.0853 21.786 40.1507 22.9349 40.1507H45.4618C46.6108 40.1507 47.5454 41.0853 47.5454 42.2342L47.5462 55.4693Z",
    fill: "#315CD5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 48,
    r: 2,
    fill: "#315CD5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanLaptopLight);
export default __webpack_public_path__ + "static/media/humanLaptopLight.a0b86a63c6207dc7150abbdcbdd1efa9.svg";
export { ForwardRef as ReactComponent };